import { Doc } from '@vibe/icons';
import { Heading, Text } from '@vibe/core';
import React from 'react';

export const WordEditorWelcomeStepContent: React.FC = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      padding: '8px 0',
    }}
  >
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '80px',
        height: '80px',
        borderRadius: '16px',
        background: '#e6f1fc',
        color: '#0073ea',
      }}
    >
      <Doc style={{ width: '48px', height: '48px' }} />
    </span>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        textAlign: 'center',
      }}
    >
      <Heading type={Heading.types.H3} weight={Text.weights.MEDIUM}>
        Welcome to GetSign Word Editor!
      </Heading>
      <Text
        align="center"
        element="p"
        type={Text.types.TEXT1}
        weight={Text.weights.NORMAL}
        color={Text.colors.SECONDARY}
      >
        Add board fields and dynamic content here, <br/> then move to the
        GetSign Pdf Editor to place signatures and <br/>send for signing.
      </Text>
    </div>
  </div>
);

export default WordEditorWelcomeStepContent;
